export default {
  strict: true,
  namespaced: true,
  state: {
    preview: false,
    brandId: '',
    details: {
      id: '',
      brandId: '',
      enable: false,
      label: '',
      code: '',
      color: '',
      allowTNC: false,
      allowTCP: false,
      allowPSC: false,
      isShared: false,
      poolP2P: false,
      poolFromAirport: false,
      poolToAirport: false,
      useShifts: false,
      isCharter: false,
      image: '',
      imageOff: '',
      name: '',
      maxPassengers: '',
      maxLuggages: '',
      excerptWeb: '',
      descriptionWeb: '',
      advantageWeb: '',
      stops: '',
      category: '',
      excerptApp: '',
      descriptionApp: '',
      advantageApp: '',
      slogan: '',
      defaultTip: 0,
      unavailableTimes: [],
      images: [],
      bufferAdminMins: '',
      bufferWidgetMins: '',
      bufferAppMins: '',
    },
    serviceUnavailable: {
      p2p: false,
      fromAirport: false,
      toAirport: false,
      startTime: 0,
      endTime: 0
    },
    saving: false
  },
  mutations: {
    setPreview (state, value) { state.preview = value },
    setBrandId (state, value) { state.brandId = value },
    setDetails (state, value) { state.details = value },
    setDetailsData (state, data) { state.details[data.field] = data.value },
    setSaving (state, value) { state.saving = value },
    addUnavailableTimes (state, value) {
      if (state.details.unavailableTimes.indexOf(value) === -1) {
        state.details.unavailableTimes.push(value)
        state.details.unavailableTimes.sort()
      }
    },
    removeUnavailableTimes (state, value) {
      let index = state.details.unavailableTimes.indexOf(value)
      if (index != -1) {
        state.details.unavailableTimes.splice(index, 1)
      }
    },
    addMoreImgs (state, value) {
      state.details.images.push(value)
    },
    removeMoreImgs (state, value) {
      let index = state.details.images.indexOf(value)
      if (index != -1) {
        state.details.images.splice(index, 1)
      }
    },
    setServiceUnavailableData (state, data) {
      for (let field in data) {
        state.serviceUnavailable[field] = data[field]
      }
    }
    // toggleServiceUnavailableTimes (state, data) {
    //   let index = state.serviceUnavailableTimes.findIndex(x => x.start === data.start && x.end === data.end)
    //   if (index > -1) state.serviceUnavailableTimes.splice(index, 1)
    //   else state.serviceUnavailableTimes.push(data)
    // }
  },
  sharedMutations: []
}


// WEBPACK FOOTER //
// ./src/store/services/details.js